<template>
  <div class="home">
    <Intro></Intro>
    <Focus id="moje-zamereni"></Focus>
    <Portfolio :portfolioLinks="portfolioLinks"></Portfolio>
    <About id="o-mne"></About>
    <Testimonials></Testimonials>
    <Message id="napiste-mi" :messageDesc="messageDesc"></Message>
    <Contact id="kontakt"></Contact>
    <Blog :blogLinks="blogLinks"></Blog>
  </div>
</template>

<script>
import axios from "axios";

import Intro from "@/components/Intro";
import Focus from "@/components/Focus";
import Portfolio from "@/components/Portfolio";
import About from "@/components/About";
import Testimonials from "@/components/Testimonials";
import Message from "@/components/Message";
import Contact from "@/components/Contact";
import Blog from "@/components/Blog";

export default {
  name: "Home",
  components: {
    Intro,
    Focus,
    Portfolio,
    About,
    Testimonials,
    Message,
    Contact,
    Blog
  },
  data() {
    return {
      portfolioLinks: [],
      blogLinks: [],
      messageDesc: 'Potřebujete zpracovat územní plán obce, nakreslit projekt rodinného domu nebo navrhnout grafiku webu? Napište mi!'
    }
  },
  created() {
    axios
      .get(
        'items/atelier_projekty?fields=type,date,heading,tags,slug,intro,intro_img.title,intro_img.id&filter[show_on_home]=true'
      )
      .then((res) => {
        if (res.status == 200) {
          this.portfolioLinks = res.data.data.filter((item) => {
            return item.type == "portfolio";
          });
          this.blogLinks = res.data.data.filter((item) => {
            return item.type == "blog";
          });
        }
      });
  },
};
</script>
<style>
.home {
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 0 48px;
  gap: 48px
}

.home > div {
  padding: 32px 0;
}

.home h2 {
  margin: 0 0 48px 0;
}

@media only screen and (min-width: 1200px) {
  .home {
    padding-left: 10vw;
    padding-right: 10vw;
  }
}
</style>